module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/gdprCookieBanner/template.html
// module id = ./components/xo-page-components/src/gdprCookieBanner/template.html
// module chunks = 1